const generateStructure = keys => keys
  .reduce((acc, key) => {
    acc[key] = [];
    return acc;
  }, {});

const fillStructure = ({ structure, items, marker }) => items
  .forEach(item => structure[item[marker]].push(item));

// queueType - key of queue items: 'queue', 'baskets'
export const generateQueues = ({ dashboardItems, queuesType }) => {
  const { machines: printMachines, [queuesType]: queuesItems } = dashboardItems;
  const queues = generateStructure(printMachines || []);

  fillStructure({
    structure: queues,
    items: queuesItems || [],
    marker: 'machine',
  });

  return queues;
};

const getEnabledOperations = ({ groups, operations }) => (operations || [])
  .filter(
    operation => (groups || [])
      .some(
        group => group.operation === operation,
      ),
  );

export const generateGroups = (dashboardItems) => {
  const groups = generateStructure(getEnabledOperations(dashboardItems));

  fillStructure({
    structure: groups,
    items: dashboardItems.groups || [],
    marker: 'operation',
  });

  return groups;
};

export const sortQueue = queue => queue.sort(({ number: a }, { number: b }) => b - a);
